export const permissions = {
  users: {
    EDIT: 'users.update',
    EDIT_ROLE: 'users.updateRole',
    EDIT_STATUS: 'users.updateActiveStatus',
    DELETE_USER: 'users.delete',
    VIEW_ALL: 'users.viewAll',
    CREATE: 'users.invite',
  },
  roles: {
    MANAGE: 'roles.manage',
    UPDATE_PERMISSIONS: 'roles.updatePermissions',
  },
  flow: {
    EDIT: 'flowEngine.update',
  },
  finishedConfigurations: {
    VIEW_ALL: 'flowEngine.viewPathways',
  },
  busLogs: {
    VIEW_ANY: 'logs.bus.viewAny',
  },
  preferences: {
    TABLE_CONFIGURATION: 'preferences.manageTableConfiguration',
  },
} as const
